import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getUrlOf, VARIABLE_URLS } from '../utils/urls';
import { setLastUrl } from './auth';

interface Props {
  className?: string;
  saveRegister?: boolean;
}

export const Register: FC<Props> = ({ className, saveRegister, children }) => {
  const { t } = useTranslation('sharedComponents');
  const register = async () => {
    if (saveRegister) {
      sessionStorage.setItem('registering', 'true');
    }
    await setLastUrl();
    window.location.href = `${getUrlOf(VARIABLE_URLS.phoenix)}${t('shared.navigation.register-path-new')}`;
  };

  return (
    <a className={className} onClick={register} href={t('shared.navigation.register-path-new')}>
      {children || t('shared.navigation.register')}
    </a>
  );
};
